import { Button, Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { ssoConfig } from '../utils/ssoConfig'

// Inline SVG icons — no extra dependencies needed

function GoogleIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
                <path
                    d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
                    fill="#4285F4"
                />
                <path
                    d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
                    fill="#34A853"
                />
                <path
                    d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
                    fill="#FBBC05"
                />
                <path
                    d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
                    fill="#EA4335"
                />
            </g>
        </svg>
    )
}

function MicrosoftIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
            <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
        </svg>
    )
}

function AppleIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 814 1000" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-42.4-150.3-109.9C77.1 751.6 44 634.9 44 525.7c0-194.3 126.4-297.5 250.8-297.5 66.1 0 121.2 43.4 162.7 43.4 39.5 0 101.1-46 176.3-46 28.5 0 130.9 2.6 198.3 99.2zm-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z"
                fill="#000"
            />
        </svg>
    )
}

export default function SocialLoginButtons({
    onGoogleLogin,
    onMicrosoftLogin,
    onAppleLogin,
    loadingProvider,
}) {
    const { enabledProviders } = ssoConfig

    if (!enabledProviders.google && !enabledProviders.microsoft && !enabledProviders.apple) {
        return null
    }

    const btnStyle = {
        width: '100%',
        height: '38px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        background: '#fff',
        border: '1px solid #d9d9d9',
        borderRadius: '6px',
        color: '#374151',
        fontSize: '14px',
        fontFamily: '"Poppins", sans-serif',
        cursor: 'pointer',
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
            {enabledProviders.google && (
                <button
                    type="button"
                    style={btnStyle}
                    onClick={onGoogleLogin}
                    disabled={!!loadingProvider}
                >
                    {loadingProvider === 'google' ? (
                        <Spin indicator={<LoadingOutlined spin style={{ fontSize: 16 }} />} />
                    ) : (
                        <GoogleIcon />
                    )}
                    <span>Continue with Google</span>
                </button>
            )}

            {enabledProviders.microsoft && (
                <button
                    type="button"
                    style={btnStyle}
                    onClick={onMicrosoftLogin}
                    disabled={!!loadingProvider}
                >
                    {loadingProvider === 'microsoft' ? (
                        <Spin indicator={<LoadingOutlined spin style={{ fontSize: 16 }} />} />
                    ) : (
                        <MicrosoftIcon />
                    )}
                    <span>Continue with Microsoft</span>
                </button>
            )}

            {enabledProviders.apple && (
                <button
                    type="button"
                    style={btnStyle}
                    onClick={onAppleLogin}
                    disabled={!!loadingProvider}
                >
                    {loadingProvider === 'apple' ? (
                        <Spin indicator={<LoadingOutlined spin style={{ fontSize: 16 }} />} />
                    ) : (
                        <AppleIcon />
                    )}
                    <span>Continue with Apple</span>
                </button>
            )}
        </div>
    )
}